export type TLMSBlueprint = {
  label: string
  id: string
}

export enum LMS_ORIGIN {
  SINDARA = 'SINDARA',
  SIMKSPSTK = 'SIMKSPSTK',
  UNKNOWN = 'UNKNOWN',
}

export const isSindaraOrigin = (origin?: LMS_ORIGIN) =>
  origin === LMS_ORIGIN.SINDARA

export function castAsTuple<T>(value: unknown): [T, T] {
  if (!value) return [undefined, undefined] as [T, T]
  return value as [T, T]
}
